import API from '@aws-amplify/api';
import { twilioInfoManagement } from '@/graphql/queries';
import { twilioUpdate } from '@/graphql/mutations';
import Utils from '@/common/utils/utils';

export const handleAction = async (requestDto) => {
    try {
        let res = await API.graphql({
            query: twilioUpdate,
            variables: {
                twilioUpdateRequestDto: requestDto
            },
        });
        let resultData = res.data.twilioUpdate;
        resultData = {...resultData, data: Utils.convertJSONDataToObject(resultData.data)}
        return resultData;
    } catch (err) {
        console.log('twilioUpdate error >>>', err)
        return null;
    }
}

export const getTwilioInfoManagement = async (params) => {
    try {
        let res = await API.graphql({
            query: twilioInfoManagement,
            variables: {
                params: {
                    ...params
                }
            },
        });
        let resultData = res.data.twilioInfoManagement;
        resultData = {...resultData, data: Utils.convertJSONDataToObject(resultData.data)}
        return resultData;
    } catch (err) {
        console.log('getTwilioInfoManagement error >>>', err)
        return { status: false, data: null };
    }
}